import { useMediaQuery } from '@mui/material';
import BudgetPercentageFields from "./BudgetPercentageFields";
import BudgetServiceSelects from "./BudgetServiceSelects";
import RemoveButton from "./RemoveButton";
import BudgetServiceFieldsMobile from "./mobile/BudgetServiceFieldsMobile";
import { ISelectedServices, IVehicleData } from '../types';
import { ITruckerPayPlanData } from '../../../../models/truckerPayPlan';

interface IBudgetServiceFieldsProps {
  serviceId: string;
  usedServices: ISelectedServices[];
  failureModeId?: string;
  isExternalService?: boolean;
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  vehicleData?: IVehicleData;
  serviceType: string;
  truckerPayPlan?: ITruckerPayPlanData;
  onServiceChange?: (serviceId: string, serviceData?: any) => void;
  onFailureModeChange?: (failureModeId: string) => void;
  onChangeServiceType?: (serviceType: string) => void;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
  onRemoveService?: () => void;
}

const BudgetServiceFields = ({
  serviceId,
  failureModeId,
  isExternalService,
  volkstotalPercentage,
  dealershipPercentage,
  warrantyPercentage,
  showPercentageFields,
  vehicleData,
  serviceType,
  truckerPayPlan,
  usedServices,
  onServiceChange,
  onFailureModeChange,
  onVolkstotalPercentageChange,
  onDealershipPercentageChange,
  onWarrantyPercentageChange,
  onRemoveService,
  onChangeServiceType,
}: IBudgetServiceFieldsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <BudgetServiceFieldsMobile
        serviceId={serviceId}
        usedServices={usedServices}
        failureModeId={failureModeId}
        isExternalService={isExternalService}
        volkstotalPercentage={volkstotalPercentage}
        dealershipPercentage={dealershipPercentage}
        warrantyPercentage={warrantyPercentage}
        showPercentageFields={showPercentageFields}
        vehicleData={vehicleData}
        serviceType={serviceType}
        truckerPayPlan={truckerPayPlan}
        onServiceChange={onServiceChange}
        onFailureModeChange={onFailureModeChange}
        onChangeServiceType={onChangeServiceType}
        onVolkstotalPercentageChange={onVolkstotalPercentageChange}
        onDealershipPercentageChange={onDealershipPercentageChange}
        onWarrantyPercentageChange={onWarrantyPercentageChange}
        onRemoveService={onRemoveService}
      />
    );
  }
  
  return (
    <div className="flex flex-col lg:flex-row gap-4 w-full items-start">
      <div className="flex flex-col lg:flex-row gap-4 items-start flex-1 min-w-0 flex-wrap">
        {!isExternalService && (
          <div className="flex w-full lg:w-auto flex-shrink-0 mb-4">
            <BudgetServiceSelects
              serviceId={serviceId}
              usedServices={usedServices}
              failureModeId={failureModeId}
              vehicleData={vehicleData}
              serviceType={serviceType}
              truckerPayPlan={truckerPayPlan}
              onChangeItem={(itemId, serviceData) => onServiceChange?.(itemId, serviceData)}
              onChangeModoFalha={(modoFalhaId) => onFailureModeChange?.(modoFalhaId)}
              onChangeServiceType={(newServiceType) => onChangeServiceType?.(newServiceType)}
            />
          </div>
        )}
        <BudgetPercentageFields
          volkstotalPercentage={volkstotalPercentage}
          dealershipPercentage={dealershipPercentage}
          warrantyPercentage={warrantyPercentage}
          showPercentageFields={showPercentageFields}
          onVolkstotalPercentageChange={onVolkstotalPercentageChange}
          onDealershipPercentageChange={onDealershipPercentageChange}
          onWarrantyPercentageChange={onWarrantyPercentageChange}
        />
      </div>
      {onRemoveService && (
        <div className="flex items-center flex-shrink-0 self-start ml-auto lg:ml-0">
          <RemoveButton label="Remover serviço" onClick={onRemoveService} />
        </div>
      )}
    </div>
  );
};

export default BudgetServiceFields;
